var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.autenticando)?_c('div',{staticClass:"modal"},[_c('img',{attrs:{"src":require("../../assets/imagens/loadingSpinner.gif"),"alt":"Roda de carregamento girando"}}),_c('label',[_vm._v("Aguarde. Autenticando.")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }